import { Header } from "./styles/Header.styled";
import { ShowCaseStyled } from "./styles/ShowCasStylede.styled";
import { ServicesStyled } from "./styles/ServicesStyled.styled";
import { Footer } from "./styles/Footer.styled";
import { Feedbacks } from "./styles/Feedbacks.styled";
import upgrade from "./Assets/upgrade.svg";
import interior from "./Assets/interior.svg";
import spraying from "./Assets/spraying.svg";
import transport from "./Assets/transport.svg";
import spare from "./Assets/spare.svg";
import dealership from "./Assets/dealership.svg";
import logo from "./Assets/logo.svg";
import section from "./Assets/section_header.jpg";
import sprayingCar from "./Assets/painting_car.jpg";
import shipping from "./Assets/shipping.jpg";
import { useEffect, useRef, useState } from "react";



const Home = () => {
  const [isClick, setIsClick] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false); // Track navigation visibility
  const [selectedNav, setSelectedNav] = useState("Home");

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  function handleSelected(selectedButton) {
    setSelectedNav(selectedButton);
  }
  return (
    <>
      <Header>
        <div id="header_wrap">
          <div className="header_top">
            <div className="container">
              <div className="container_bg">
                <div className="site_branding">
                  <a href="/" rel="home" title="Multitibe">
                    <img src={logo} alt="Multitibe" />
                  </a>
                </div>
                <div className="contact_wrap">
                  <div className="animated_contact_info">
                    <div className="location flex_icon ">
                      <a href="/">
                        <i class="fa-solid fa-location-dot"></i>
                      </a>
                      <p>
                        <label htmlFor="">ADDRESS </label>
                        <br />
                        5, Olusoji Idowu Street, Ilupeju, Lagos
                      </p>
                    </div>
                    <div className="phone flex_icon">
                      <a href="tel: +234 703 957 1467">
                        <i className="fa-solid fa-phone-volume fa-shake"></i>
                      </a>
                      <p>
                        <label htmlFor="">CALL US</label>
                        <br />
                        +234 703 957 1467
                      </p>
                    </div>
                  </div>
                  <div className="social_icons">
                    <a
                      className="fa"
                      href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                      title="Facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-facebook-f custom-icon"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                      title="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                      title="Tiktok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header_bottom">
            <div className="container">
              <nav className="main_navigation">
                <ul>
                  <li>
                    <a
                      href="/"
                      className={selectedNav === "Home" ? "active" : ""}
                      onCLick={() => handleSelected("Home")}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      className={selectedNav === "About" ? "active" : ""}
                      onCLick={() => handleSelected("About")}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="/services"
                      className={selectedNav === "Services" ? "active" : ""}
                      onCLick={() => handleSelected("Services")}
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="/contact"
                      className={selectedNav === "Contact" ? "active" : ""}
                      onCLick={() => handleSelected("Contact")}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="mobile_container">
                <div className="open-menu" onClick={toggleNav}>
                  {!isClick ? (
                    <i
                      class="fa-solid fa-bars"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  ) : (
                    <i class="fa-solid fa-x"></i>
                  )}
                </div>
                {isNavVisible && (
                    <nav className="mobile_navigation">
                      <ul>
                        <li>
                          <a
                            href="/"
                            className={
                              selectedNav === "Home" ? "mobile_active" : ""
                            }
                            onCLick={() => handleSelected("Home")}
                          >
                            Home
                          </a>
                        </li>
                        <li>
                          <a
                            href="/about"
                            className={
                              selectedNav === "About" ? "mobile_active" : ""
                            }
                            onCLick={() => handleSelected("About")}
                          >
                            About
                          </a>
                        </li>
                        <li>
                          <a
                            href="/services"
                            className={
                              selectedNav === "Services" ? "mobile_active" : ""
                            }
                            onCLick={() => handleSelected("Services")}
                          >
                            Services
                          </a>
                        </li>
                        <li>
                          <a
                            href="/contact"
                            className={
                              selectedNav === "Contact" ? "mobile_active" : ""
                            }
                            onCLick={() => handleSelected("Contact")}
                          >
                            Contact
                          </a>
                        </li>
                      </ul>
                    </nav>
                  )}
                {/* <div className="open-menu">
                  <i
                    class="fa-solid fa-bars"
                    style={{ marginLeft: "10px" }}
                  ></i>
                </div>
                <nav className="mobile_navigation">
                  <ul>
                    <li>
                      <a
                        href="/"
                        className={
                          selectedNav === "Home" ? "mobile_active" : ""
                        }
                        onCLick={() => handleSelected("Home")}
                      >
                        Home
                      </a>
                    </li>
                    <li>
                      <a
                        href="/about"
                        className={
                          selectedNav === "About" ? "mobile_active" : ""
                        }
                        onCLick={() => handleSelected("About")}
                      >
                        About
                      </a>
                    </li>
                    <li>
                      <a
                        href="/services"
                        className={
                          selectedNav === "Services" ? "mobile_active" : ""
                        }
                        onCLick={() => handleSelected("Services")}
                      >
                        Services
                      </a>
                    </li>
                    <li>
                      <a
                        href="/contact"
                        className={
                          selectedNav === "Contact" ? "mobile_active" : ""
                        }
                        onCLick={() => handleSelected("Contact")}
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </nav> */}
              </div>
            </div>
          </div>
        </div>
      </Header>
      <main className="site-main">
        <ShowCase/>
        <ServicesStyled>
          <div className="container">
            <div style={{ textAlign: "center", paddingTop: "150px" }}>
              <h4 className="h4">WE OFFER SERVICES</h4>
              <h2>Our car services</h2>
            </div>
            <div className="services">
              <div className="service">
                <img src={dealership} alt="upgrade" />

                <div className="content">
                  <div className="content_header">
                    <h4>Automobile Dealership</h4>
                    <p>
                      We offer both brand-new and carefully selected pre-owned
                      vehicles that meet international standards.
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
              <div className="service">
                <img src={spraying} alt="upgrade" />

                <div className="content">
                  <div className="content_header">
                    <h4>Auto Spray Services</h4>
                    <p>
                      Our auto spray division delivers professional
                      spray-painting and bodywork services that transform
                      vehicles to showroom-standard condition..
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
              <div className="service">
                <img src={upgrade} alt="upgrade" />
                <div className="content">
                  <div className="content_header">
                    <h4>Automobile Upgrading</h4>
                    <p>
                      Give your car a new life with our professional automobile
                      upgrade services
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
              <div className="service">
                <img src={interior} alt="upgrade" />

                <div className="content">
                  <div className="content_header">
                    <h4>Auto Interior Services</h4>
                    <p>
                      We specialize in designing and upgrading automobile
                      interiors to achieve a luxury finish.
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
              <div className="service">
                <img src={transport} alt="upgrade" />
                <div className="content">
                  <div className="content_header">
                    <h4>Import & Export Trade</h4>
                    <p>
                      We specialize in sourcing and delivering high quality
                      vehicles from trusted markets worldwide.
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
              <div className="service">
                <img src={spare} alt="upgrade" />

                <div className="content">
                  <div className="content_header">
                    <h4>Spare Parts</h4>
                    <p>
                      We provide genuine spare parts, premium accessories, and
                      essential auto components tailored to meet your vehicle’s
                      needs.
                    </p>
                  </div>
                  <a href="/services">READ MORE</a>
                </div>
              </div>
            </div>
          </div>
        </ServicesStyled>

        <Feedbacks>
          <div className="container">
            <div className="feedback_container">
              <div style={{ textAlign: "center", paddingTop: "100px" }}>
                <h4>TESTIMONIES</h4>
                <h2>Happy Clients & Feedbacks</h2>
              </div>
              <div className="feedbacks">
                <div className="feedback">
                  <i class="fa-solid fa-quote-left"></i>
                  <div className="context_feedback">
                    <p>
                      Professional, reliable, and trustworthy. From payment to
                      delivery, everything was handled perfectly. Multibe Autos
                      LTD is now my go-to auto partner
                    </p>
                    <div className="profile">
                      <div className="title">
                        <h2>Fatima L.</h2>
                        <p>Kano State</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="feedback">
                  <i class="fa-solid fa-quote-left"></i>
                  <div className="context_feedback">
                    <p>
                      I upgraded my vehicle’s interior with Multibe Autos, and
                      the result was amazing. The attention to detail and
                      quality of materials exceeded my expectations
                    </p>
                    <div className="profile">
                      <div className="title">
                        <h2>Aishat B.</h2>
                        <p>Abuja</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="feedback">
                  <i class="fa-solid fa-quote-left"></i>
                  <div className="context_feedback">
                    <p>
                      Their spray-painting service is top-notch. My car looks
                      brand new again. The finish is flawless, and the delivery
                      was right on time
                    </p>
                    <div className="profile">
                      <div className="title">
                        <h2>Micheal K</h2>
                        <p>Port Harcourt</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Feedbacks>
      </main>
      <Footer>
        <div className="container">
          <div className="footer_section">
            <div className="section_1 section_width">
              <h3>Multibe Autos</h3>
              <p>
                Multibe Autos is your trusted partner for all your automotive
                needs.
              </p>
              <div className="social_icons">
                <a
                  className="fa"
                  href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                  title="Facebook"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-facebook-f custom-icon"></i>
                </a>
                <a
                  href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                  title="Instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                  title="Tiktok"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </div>
            </div>
            <div className="section_2 section_width">
              <h3>Services</h3>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Interior Services
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Spray Services
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Automobile Upgrading
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Automobile Dealership
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Import & Export Trade
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Spare Parts
                </a>
              </li>
            </div>
            <div className="section_3 section_width">
              <h3>Contact information</h3>
              <li>
                <i class="fa-solid fa-location-dot"></i>
                <span style={{ opacity: 0.7 }}>
                  5, Olusoji Idowu Street, Ilupeju, Lagos
                </span>
              </li>
              <li>
                <i class="fa-solid fa-phone"></i>
                <span>
                  +234 703 957 1467 <br /> +234 810 3690 175{" "}
                </span>
              </li>
              <li>
                <i class="fa-solid fa-envelope"></i>
                <span>info@multibeauto.com</span>
              </li>
            </div>
            <div className="section_4 section_width">
              <h3>Business Hours</h3>
              <dl>
                <dt>Opening Days:</dt>
                <dd>Monday – Friday : 8:00am to 5:00pm</dd>
                <dd>Saturday : 9:00am to 4:00pm</dd>
                <dt>Vacations:</dt>
                <dd>All Sunday Days All Official</dd>
                <dd>Holidays</dd>
              </dl>
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              padding: "20px 0",
              paddingBottom: "70px",
            }}
          >
            &copy; {new Date().getFullYear()} Multibe Autos. All rights
            reserved.
          </p>
        </div>
      </Footer>
    </>
  );
};

const showcaseImages = [section, sprayingCar, shipping];

const ShowCase = () => {
  const [bgIndex, setBgIndex] = useState(0);
  const timerRef = useRef();

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setBgIndex((prev) => (prev + 1) % showcaseImages.length);
    }, 5000);
    return () => clearTimeout(timerRef.current);
  }, [bgIndex]);

  return (
    <ShowCaseStyled bg={showcaseImages[bgIndex]}>
     <div className="container">
            <div className="showcase_wrap">
              <div className="text_container">
                <span>WE CARE ABOUT YOUR CAR</span>
                <h1>Make your car last longer</h1>
                <a href="/contact">BOOK AN APPOINTMENT</a>
              </div>
              <div className="appointment">
                <div className="appointment_text">
                  <i class="fa-solid fa-screwdriver-wrench"></i>
                  <p>
                    Are you ready?<span> Let's repair it now!</span>
                  </p>
                </div>
                <a href="/contact">Book an appointment</a>
              </div>
            </div>
          </div>
    </ShowCaseStyled>
  );
};

export default Home;
